<template lang="pug">
.laudo-listagem.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            :data='tableData',
            @sort-change='sortChangeRequest',
            stripe,
            height='1000'
        )
            el-table-column(
                v-if='showAnalystColumns',
                width='50',
                prop='id',
                label='ID',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.id || '--' }}
            el-table-column(
                prop='codigo',
                :label='$t("laudos.gridColunaHash")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.codigo || '--' }}
            el-table-column(
                prop='informacaoLaudo.nomeTerritorio',
                :label='$t("laudos.territorio")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.informacaoLaudo.nomeTerritorio || '--' }}
            el-table-column(
                prop='informacaoLaudo.nomeRepresentante',
                :label='$t("laudos.pessoa")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.informacaoLaudo.nomeRepresentante || '--' }}
            el-table-column(
                prop='dataCadastroFormatado',
                :label='$t("laudos.dataSolicitacao")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.dataCadastroFormatado || '--' }}
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label='$t("laudos.dataEntrega")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.dataFinalizacaoFormatado || '--' }}
            el-table-column(
                prop='situacao',
                :label='$t("laudos.situacao")',
                sortable='custom'
            )
                template(slot-scope='scope')
                    span(
                        :class='["situacao", classeSituacao.get(scope.row.situacao.codigo)]'
                    ) {{ traduzirSituacao(scope.row.situacao.nome) }}

            el-table-column(
                v-if='showAnalystColumns',
                prop='situacaoAnalise',
                :label='$t("laudos.situacaoAnalise")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.situacaoAnalise || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioAnaliseNome',
                :label='$t("laudos.analistaResponsavel")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.usuarioAnaliseNome || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioSolicitacaoNome',
                :label='$t("mensagens.comuns.solicitante")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.usuarioSolicitacaoNome || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='nomeEmpresa',
                :label='$t("laudos.empresa")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.nomeEmpresa || '--' }}
            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                align='left'
            )
                template(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='showModalVisualizacao(scope.row)'
                            ) {{ $t('laudos.visualizarLaudo') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "PROCESSADO" && showAnalystColumns',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('laudos.baixarLaudo') }}
                            el-dropdown-item(
                                v-if='scope.row.informacaoLaudo.tipoInsumo !== "ARQUIVO_PDF" && showAnalystColumns',
                                icon='el-icon-download',
                                @click.native='baixarDados(scope.row)'
                            ) {{ $t('laudos.baixarShape') }}
                            el-dropdown-item(
                                v-if='scope.row.informacaoLaudo.tipoInsumo === "ARQUIVO_PDF" && showAnalystColumns',
                                icon='el-icon-download',
                                @click.native='baixarPdf(scope.row)'
                            ) {{ $t('laudos.baixarPdf') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "EM_PROCESSAMENTO" && scope.row.informacaoLaudo.baseDados === "DADOS_ATUALIZADOS" && showAnalystColumns',
                                icon='el-icon-upload',
                                @click.native='abreModalInserirResultado(scope.row)'
                            ) {{ $t('laudos.enviarResultado') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "EM_PROCESSAMENTO" && scope.row.informacaoLaudo.baseDados === "DADOS_HISTORICOS" && scope.row.informacaoLaudo.tipoInsumo === "ARQUIVO_PDF" && showAnalystColumns',
                                icon='el-icon-upload',
                                @click.native='abreModalInserirArquivoVetorial(scope.row)'
                            ) {{ $t('laudos.enviarArquivoVetorial') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "PROCESSADO" && showAnalystColumns',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('laudos.baixarResultado') }}
    EmptyResultLaudo(
        v-else,
        :semLaudoSelecionado='false',
        :p1='$t("mensagens.comuns.semDados")',
        :p2='$t("laudos.naoConseguimosLocalizarNenhumLaudo")'
    )
</template>

<script>
import LaudosService from '@/modules/laudos/services/LaudosService';
import UtilsService from '@/modules/laudos/services/UtilsService';
import AuthService from '@/services/AuthService';
import { classe } from '@/modules/laudos/utils/laudoSituacao';
import EmptyResultLaudo from '@/modules/laudos/components/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagem',
    components: {
        EmptyResultLaudo
    },
    props: {
        tableData: {
            type: Array,
            required: true
        },
        showAnalystColumns: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            idKeycloak: '',
            classeSituacao: classe
        };
    },
    created() {
        AuthService.isLogged().then(({ data }) => {
            this.idKeycloak = data.idKeyCloack;
        });
    },
    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');

            return this.$t(`laudos.situacoes.${normalizedSituacao}`);
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            const params = {
                order: column.order === 'ascending' ? 'ASC' : 'DESC',
                column: prop
            };

            this.$emit('handleSort', params);
        },
        showModalVisualizacao(row) {
            this.$emit('handleModalLaudo', row.id);
        },
        baixarDados(row) {
            UtilsService.baixarArquivo(
                `/laudo/${row.id}/shape/${this.idKeyCloack}`
            );
            setTimeout(this.atualizarTabela, 1500);
        },
        baixarPdf(row) {
            LaudosService.downloadArquivoLaudo(row.arquivos[0].id);
        },
        abreModalInserirResultado(row) {
            this.$emit('handleModalInsercaoResultados', row);
        },
        abreModalInserirArquivoVetorial(row) {
            this.$emit('handleModalVetorial', row);
        },
        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('laudos.downloadRealizadoComSucesso')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('laudos.erro.erroAoRealizarDownload')
                    });
                });
        },
        atualizarTabela() {
            this.$emit('atualizar');
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    max-height: 1400px;
}

.el-table {
    .cell {
        word-break: break-word !important;
    }

    .action-button {
        cursor: pointer;
    }
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
}

.situacao {
    border-radius: 50px;
    text-align: center;
}

.conforme {
    background-color: #d5f8d7;
    border: 1px solid #b0dcb3;
    color: #b0dcb3;
}

.nao-conforme {
    background-color: #f7d6da;
    border: 1px solid #e58585;
    color: #e58585;
}

.inconclusivo {
    background-color: #f7e0bf;
    border: 1px solid #e5b385;
    color: #e5b385;
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
}
</style>
